<style>
.slide {
    margin-top: -16px;
}
.slide1 {

}
.slide2 {

}
.slide3 {

}
.info_button {
    display: flex;
    align-items: center;
    font-size: 14px;
    line-height: 14px;
    text-align: center;
    color: #404455;
    justify-content: center;
}
.top_plus {
    display: block;
    width: 19px;
    height: 19px;
    background-image: url("./images/plus.svg");
    background-size: 17px;
    background-position: center;
    background-repeat: no-repeat;
    border: 1px solid #FF0000;
    border-radius: 10px;
    margin-left: 14px;
    margin-top: 2px;
}
.bot_plus {
    display: block;
    width: 14px;
    height: 14px;
    background-image: url("./images/plus.svg");
    background-size: 10px;
    background-position: center;
    background-repeat: no-repeat;
    border-radius: 10px;
    margin-left: 14px;
    margin-top: 2px;
}
.bot_plus {

}
.info_description {
    font-size: 14px;
    line-height: 13px;
    text-align: center;
    color: #404455;
}
.img_slide {
    display: block;
    width: 202px;
    margin: 22px auto;
}
.img_slide.big {
    width: 268px;
}
.header_text {
    font-weight: 600;
    font-size: 16px;
    line-height: 15px;
    text-align: center;
    color: #404455;
    padding-bottom: 25px;
}
.indicator {
    margin-top: 25px;
    margin-bottom: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.indicator_item {
    width: 4px;
    height: 4px;
    border-radius: 4px;
    background: #C4C4C4;
    margin-left: 7px;
    margin-right: 7px;
    cursor: pointer;
}
.indicator_item.active {
    background: #828282;
}
.button_group {
    display: flex;
    align-items: center;
    justify-content: center;
}
.button_group button {
    margin-left: 10px;
    margin-right: 10px;
    width: 135px;
    height: 48px;
    background: #FF0000!important;
    border: 1px solid #FF0000;
    box-sizing: border-box;
    border-radius: 5px;
    color: #FFFFFF!important;
    font-weight: bold;
    cursor: pointer;
    transition: 0.25s;
    line-height: 0.9;
}
.button_group button:hover {
    background-color: #DD0000!important;
    color: #FFFFFF;
}
.button_group button:active, .button_group button:focus {
    background-color: #FF0000!important;;
    color: #FFFFFF!important;
    box-shadow: 0 0 0 0.2rem #FF000060;
}
.button_group button:nth-child(1) {
    background: #FFFFFF!important;
    border: 1px solid #FF0000;
    color: #FF0000!important;
}
.button_group button:nth-child(1):hover {
    background-color: #FF0000!important;
    color: #FFFFFF!important;
}
.button_group button:nth-child(1):active, .button_group button:nth-child(1):focus {
    background-color: #FF0000!important;;
    color: #FFFFFF!important;
    box-shadow: 0 0 0 0.2rem #FF000060;
}
</style>

<script>
import { mutations, modalState} from '../mainStore.js';

function next() {
    mutations.setModalState($modalState + 1)
}
function back() {
    mutations.setModalState($modalState - 1)
}
function cancel() {
    mutations.setShowModal(false)
    // mutations.setModalTitle("")
    // mutations.setModalType(null)
    // mutations.setModalState(null)
}
</script>

<div>
    {#if ($modalState == 1)}
        <div class="slide slide1">
            <div class="header_text">
                Наполните<br> верхний ярус
            </div>
            <div class="info_button">
                <span>
                    Кнопка добавления:
                </span>
                <span class="top_plus"></span>
            </div>
            <img class="img_slide" src="/build/images/faq1.png" alt="">
            <div class="info_description">
                На верхнем ярусе ставятся:<br> кондиционеры, вытяжки и т.п.<br> оборудование
            </div>
            <div class="indicator">
                <div class="indicator_item active" on:click={()=>{mutations.setModalState(1)}}></div>
                <div class="indicator_item" on:click={()=>{mutations.setModalState(2)}}></div>
                <div class="indicator_item" on:click={()=>{mutations.setModalState(3)}}></div>
            </div>
            <div class="button_group">
                <button on:click={back} style="display: none;">Назад</button>
                <button on:click={next}>Вперед</button>
            </div>
        </div>
    {/if}
    {#if ($modalState == 2)}
        <div class="slide slide2">
            <div class="header_text">
                Наполните <br>нижний ярус
            </div>
            <div class="info_button">
                <span>
                    Кнопка добавления:
                </span>
                <span class="top_plus"></span>
            </div>
            <img class="img_slide" src="/build/images/faq2.png" alt="">
            <div class="info_description">
                На нижнем ярусе ставятся:<br>
                шкафы, мойки, холодильники и <br>множество другого оборудования
            </div>
            <div class="indicator">
                <div class="indicator_item" on:click={()=>{mutations.setModalState(1)}}></div>
                <div class="indicator_item active" on:click={()=>{mutations.setModalState(2)}}></div>
                <div class="indicator_item" on:click={()=>{mutations.setModalState(3)}}></div>
            </div>
            <div class="button_group">
                <button on:click={back}>Назад</button>
                <button on:click={next}>Вперед</button>
            </div>
        </div>
    {/if}
    {#if ($modalState == 3)}
        <div class="slide slide3">
            <div class="header_text">
                Перемещайте <br>оборудование простым <br>перетаскиванием
            </div>
            <img class="img_slide big" src="/build/images/faq3.png" alt="">
            <div class="info_description">
                Зелёные области – это место, в<br> котором возможно размещение<br> перетаскиваемого объекта
            </div>
            <div class="indicator">
                <div class="indicator_item" on:click={()=>{mutations.setModalState(1)}}></div>
                <div class="indicator_item" on:click={()=>{mutations.setModalState(2)}}></div>
                <div class="indicator_item active" on:click={()=>{mutations.setModalState(3)}}></div>
            </div>
            <div class="button_group">
                <button on:click={back}>Назад</button>
                <button on:click={cancel}>Начать сборку</button>
            </div>
        </div>
    {/if}
</div>
